import React from "react";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";

function Erro() {
  return (
    <AppLayout>
      <div className="verify-container">
        <h2>❌ Pagamento não concluído</h2>
        <p>Ocorreu um problema com seu pagamento. Tente novamente.</p>
      </div>
      <Footer />
    </AppLayout>
  );
}

export default Erro;
